import PropTypes from 'prop-types';

import Icon from 'components/commons/Icon';
import { Button, IconWrapper } from './styles';

const SortedButton = ({
  onClick,
  name,
  column,
  direction,
  selected,
  children,
}) => {
  const handleClick = () => {
    onClick({ column, name, direction, type: 'button' });
  };

  return (
    <Button
      type="button"
      data-column={column}
      data-sort={direction}
      onClick={handleClick}
      selected={selected}
    >
      {children}

      {selected && (
        <IconWrapper>
          <Icon name="check" />
        </IconWrapper>
      )}
    </Button>
  );
};

SortedButton.propTypes = {
  direction: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  column: PropTypes.string,
  selected: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

SortedButton.defaultProps = {
  column: null,
  selected: false,
};

export default SortedButton;
